export default "__VITE_ASSET__9f43a5ab__"